var React = require('react');

function IcStarRate18px (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 11.3l3.71 2.7-1.42-4.36L15 7h-4.55L9 2.5 7.55 7H3l3.71 2.64L5.29 14z"}));
}

IcStarRate18px.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = IcStarRate18px;

IcStarRate18px.default = IcStarRate18px;
